import createIcon from "components/elements/Icons/create-icon";

export default createIcon("CirclePlus", [
  [
    "path",
    {
      d: "M12.5 11V11.5H13H16C16.2762 11.5 16.5 11.7238 16.5 12C16.5 12.2762 16.2762 12.5 16 12.5H13H12.5V13V16C12.5 16.2762 12.2762 16.5 12 16.5C11.7238 16.5 11.5 16.2762 11.5 16V13V12.5H11H8C7.72386 12.5 7.5 12.2762 7.5 12C7.5 11.7238 7.72386 11.5 8 11.5H11H11.5V11V8C11.5 7.72386 11.7238 7.5 12 7.5C12.2762 7.5 12.5 7.72386 12.5 8V11ZM12 2.5C6.7533 2.5 2.5 6.7533 2.5 12C2.5 17.2467 6.7533 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.7533 17.2467 2.5 12 2.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z",
    },
  ],
]);
